import React from 'react';
import { Shield } from 'lucide-react';

/**
 * @component PrivacyAssurance
 * @description Component displaying privacy commitment for high-value clients
 * @returns {JSX.Element} Privacy assurance section for footer or dedicated page
 */
const PrivacyAssurance: React.FC = () => {
  return <div className="flex items-center space-x-3 py-3 border-t border-forti-fi-lavender/10">
      <div className="flex-shrink-0">
        <Shield className="h-5 w-5 text-gold" />
      </div>
      <p className="text-sm text-forti-fi-charcoal/80 text-slate-50">
        <strong className="text-forti-fi bg-slate-50/0">Your Privacy is Paramount</strong> — Forti-Fi maintains the strictest confidentiality standards in all client engagements. Your information is never shared with third parties.
      </p>
    </div>;
};
export default PrivacyAssurance;